import clsx from 'clsx';
import Carousel, { type CarouselProps } from 'nuka-carousel';
import type { ComponentType, ReactNode } from 'react';

import c from './_brandLogoCarousel.module.scss';

const CarouselWithChildren = Carousel as ComponentType<CarouselProps & { children?: ReactNode }>;

export interface BrandLogo {
  id: number;
  imageUrl: string;
}

export interface BrandLogoCarouselProps {
  logos: BrandLogo[];
  slidesToShow?: number;
  className?: string;
}

export function BrandLogoCarousel({ logos, slidesToShow = 4, className }: BrandLogoCarouselProps) {
  if (!logos.length) return null;

  const effectiveSlidesToShow = Math.min(logos.length, slidesToShow);

  return (
    <div className={clsx('brandLogoCarousel', c.wrapper, className)} data-testid="brand-logo-carousel">
      <CarouselWithChildren
        autoplay
        autoplayInterval={1000}
        wrapAround
        withoutControls
        autoGenerateStyleTag={false}
        slidesToShow={effectiveSlidesToShow}
      >
        {logos.map((logo) => {
          return (
            <img
              key={logo.id}
              src={logo.imageUrl}
              alt={`Brand logo ${logo.id}`}
              className={clsx('brandLogoCarousel__logo', c.brandLogoCarouselLogo)}
            />
          );
        })}
      </CarouselWithChildren>
    </div>
  );
}
